import {
  DisplayProperties,
  LevelType
} from '@com-delta-idp/mnx-skymiles-shared';
import { Image, Link } from '@com-delta-idp/mnx-ui-kit';

export interface Cards {
  image: Image;
  link: Link;
  tag?: string;
  label?: string;
  title: string;
  type: LevelType;
}

export interface Upgrades extends DisplayProperties {
  title: string;
  action: Link;
  cards: Cards[];
}
